module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"table":{"header":{"symbol":"識別","insect_type":"虫種","count":"カウント","radio":"描画"},"footer":{"total":"合計"}},"button":{"close":"閉じる"}},"en":{"table":{"header":{"symbol":"Symbol","insect_type":"Type","count":"Count","radio":"Draw"},"footer":{"total":"Total"}},"button":{"close":"Close"}}}')
  delete Component.options._Ctor
}
